let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cCZrG")).then(() => parcelRequire('3zJQS'));